import React from 'react';
import { useTranslation } from 'react-i18next';
import Select, {
  IProps as ISelectProps,
  IValue,
  IValues,
} from '../../../../components/_select/_module/Select';

interface IProps<TValue extends IValue | IValues>
  extends ISelectProps<TValue> {}

export default function SelectAfrica<TValue extends IValue | IValues>(
  props: IProps<TValue>
) {
  const { t } = useTranslation();
  const {
    creatable,
    disabled,
    label,
    onChange,
    placeholder,
    value,
    menuPosition,
    required,
    margin,
    error,
    fullWidth,
    helperText,
    isMulti,
  } = props;
  return (
    <Select<TValue>
      isClearable
      options={[
        {
          label: t('northern_africa'),
          value: 'northern_africa',
        },
        {
          label: t('western_africa'),
          value: 'western_africa',
        },
        {
          label: t('middle_africa'),
          value: 'middle_africa',
        },
        {
          label: t('eastern_africa'),
          value: 'eastern_africa',
        },
        {
          label: t('southern_africa'),
          value: 'southern_africa',
        },
      ]}
      creatable={creatable}
      menuPosition={menuPosition}
      label={label || t('africa')}
      required={required}
      margin={margin}
      isMulti={isMulti}
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      helperText={helperText}
      value={value}
      onChange={onChange}
      placeholder={placeholder || t('please_select')}
    />
  );
}
